/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_Stack_QuestionInputs */

const en_landing_faq_stack_question = /** @type {(inputs: Landing_Faq_Stack_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the tech stack?`)
};

const zh_landing_faq_stack_question = /** @type {(inputs: Landing_Faq_Stack_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用的是什么技术栈？`)
};

/**
* | output |
* | --- |
* | "What's the tech stack?" |
*
* @param {Landing_Faq_Stack_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_stack_question = /** @type {((inputs?: Landing_Faq_Stack_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_Stack_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_stack_question(inputs)
	return zh_landing_faq_stack_question(inputs)
});
export { landing_faq_stack_question as "landing.faq.stack.question" }